export default "__VITE_ASSET__IhRXnAwZ__"